// Fechas y plazos de las solicitudes de datos personales · TODO-SIRVE F2.
//
// Viven aparte de las pantallas para poder probarlos y para que «Mi
// cuenta» y la bandeja digan la misma fecha de la misma forma.

// «2026-10-28» → «28/10/2026», sin pasar por Date (que la correría de día
// según el huso del teléfono).
export function fechaCorta(iso) {
  if (!iso) return '—';
  const [a, m, d] = String(iso).slice(0, 10).split('-');
  return d && m && a ? `${d}/${m}/${a}` : String(iso);
}

// Días naturales que faltan para la fecha límite (negativo: ya pasó).
export function diasParaLimite(iso, hoy = new Date()) {
  if (!iso) return null;
  const [a, m, d] = String(iso).slice(0, 10).split('-').map(Number);
  const limite = Date.UTC(a, m - 1, d);
  const hoyUtc = Date.UTC(hoy.getFullYear(), hoy.getMonth(), hoy.getDate());
  return Math.round((limite - hoyUtc) / 86400000);
}

// Los colores de siempre: verde bien, amarillo a cinco días o menos, rojo
// cuando ya pasó.
export function colorDelPlazo(dias) {
  if (dias === null) return 'text-gray-700 bg-gray-50 border-gray-200';
  if (dias < 0) return 'text-red-700 bg-red-50 border-red-200';
  if (dias <= 5) return 'text-amber-900 bg-amber-50 border-amber-200';
  return 'text-green-800 bg-green-50 border-green-200';
}
